import React from 'react';
import { get } from 'lodash';

import { Field, useFormikContext } from 'formik';

import {
  AuErrorText,
  AuInputLabel,
  AuHintText,
  AuFormItemWrapper
} from 'components/DTA';

import './AuSelect.scss';

export interface IAuSelectOption {
  text: string;
  value: string | number | null;
}

/**
 * An item inside the Select component
 */
export const AuSelectOption: React.FC<IAuSelectOption> = ({ text, value }) => (
  <option value={value || ''}>{text}</option>
);

interface IAuSelect {
  name: string;
  label?: string;
  className?: string;
  hintText?: string;
  dark?: boolean;
  block?: boolean;
  number?: boolean;
  disabled?: boolean;
  width?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  options: Array<IAuSelectOption>;
  style?: React.CSSProperties;
}

/**
 * DEFAULT
 * The select component
 */
const AuSelect: React.FC<IAuSelect> = ({ label, hintText, dark, options, block = false, disabled = false, className = '', ...attributeOptions }) => {
  const form = useFormikContext();
  const errors = get(form.errors, attributeOptions.name);

  return (
    <AuFormItemWrapper>
      {
        label && <AuInputLabel text={label} htmlFor={attributeOptions.name} />
      }
      {
        hintText && <AuHintText text={hintText} htmlFor={attributeOptions.name} />
      }
      <Field as='select'
        className={
          `au-select ${className}` +
          `${block ? ' au-select--block' : ''}` +
          `${dark ? ' au-select--dark' : ''}` +
          `${errors && !disabled ? ' au-select--invalid' : ''}`
        }
        disabled={disabled}
        {...attributeOptions}
      >
        {
          options.map(
            option => <AuSelectOption key={option.value} {...option} />
          )
        }
      </Field>

      {errors && !disabled &&
        <AuErrorText text={get(form.errors, attributeOptions.name)} />
      }
    </AuFormItemWrapper>
  );
};

export default AuSelect;
